export default __webpack_public_path__ + "media/images/brighteon-social/Icon-Add-Gray-d37218f86360ad49e897ccdac171747a.svg";